import { render, staticRenderFns } from "./MonthlyScoreBesResult.vue?vue&type=template&id=518585c6&"
import script from "./MonthlyScoreBesResult.vue?vue&type=script&lang=js&"
export * from "./MonthlyScoreBesResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports